<!--
 * @Author: ymk
 * @Date: 2020-07-28 18:31:22
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 18:46:30
 * @FilePath: \car-demo\src\views\Ranking\index.vue
-->
<template>
	<div class="ranking">
		<div class="bg"></div>

		<div class="tab">
			<router-link
				class="tab-item"
				v-for="item in tabData"
				:to="{ name: item.name }"
				:key="item.id"
                exact
			>{{ item.label }}</router-link>
		</div>
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'ranking',
	metaInfo: {
		title: '打赏排行',
		titleTemplate: null,
	},
	data: () => ({
		tabData: [
			{ label: '教练红人榜', id: 1, name: 'Instructor' },
			{ label: '金牌打赏人', id: 2, name: 'Customer' },
		],
		current: 0,
	}),
}
</script>

<style lang="less" scoped>
.bg {
	position: absolute;
	top: 0;
	left: 0;
	z-index: -1;
	width: 100%;
	height: 200px;
	background: linear-gradient(
		225deg,
		rgba(0, 194, 255, 1) 0%,
		rgba(60, 67, 236, 1) 100%
	);
}
.tab {
	display: flex;
	&-item {
		flex-grow: 1;
		text-align: center;
		color: rgba(255, 255, 255, 0.8);
		padding: 15px 0;
	}
	.router-link-active {
		position: relative;
		color: #ffffff;
		font-size: 16px;
		font-weight: bold;
		&::before {
			content: '';
			position: absolute;
			left: 50%;
			margin-left: -20px;
			width: 40px;
			height: 2px;
			background-color: #fff;
			bottom: 5px;
		}
	}
}
</style>
